import {
  Badge,
  Col,
  Descriptions,
  Modal,
  Spin,
  Card,
  Popconfirm,
  Button,
} from "antd";
import Title from "antd/lib/typography/Title";
import React, { useState, useEffect, useRef } from "react";
import FormSelect from "../general/FormSelect";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import { useSelector } from "react-redux";
import { postRequest } from "../../services/mainApp.service";
import { submitForm } from "../../redux/actions/basicFormAction";
import CustomButton from "../NewComponents/CustomButton";
import { getOrderStatuses } from "../../utils/OrderPageFunctions";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import RiderSelectModal from "./RiderSelectModal";
import OrderTransfer from "./OrderTransfer";
import {
  CheckCircle,
  Clock,
  MapPin,
  Phone,
  Truck,
  User,
  X,
  Package,
  Building,
  Navigation,
  Receipt,
  Calendar,
  DollarSign,
  Copy
} from "lucide-react";
import ygen from "../../assets/images/ygen.png";
const controller = new window.AbortController();
import { message } from "antd";
import ReceiptPrint from "../NewComponents/SalesReceipt";
import { AGENT, CALL_CENTER_ADMIN, BRANCH_ADMIN, CASHIER } from "../../common/SetupMasterEnum";

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    message.success("Copied to clipboard: " + text);
  }).catch((err) => {
    console.error("Failed to copy: ", err);
  });
};


const ViewOrderModal = (props) => {
  let {
    viewOrder,
    data,
    toggleViewOrder,
    isMainPage,
    onUpdateOrders,
    ridersData,
    branchList,
    fetchLatestOrders = () => { },
    allowStatusChange = true,
  } = props;

  const {
    OrderMasterId,
    AreaId,
    OrderSourceId,
    AreaName,
    OrderNumber,
    OrderDate,
  } = data?.Table[0] || {};
  const controller = new window.AbortController();
  const [isStatusChange, setIsStatusChange] = useState(false);

  // order transfer into another branch
  const [isBranchModalOpen, setIsBranchModalOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);

  // riders states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRider, setSelectedRider] = useState(null);

  const [orderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);

  const DateRefFrom = useRef({});
  const DateRefTo = useRef({});
  const [supportingTable, setSupportingTable] = useState();
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [orderItemsDetail, setOrderItemsDetail] = useState([]);

  const { formFields, itemList, formLoading, tableLoading } = useSelector(
    (state) => state.basicFormReducer
  );
  const userData = useSelector((state) => state.authReducer);
  const { userBranchList } = useSelector((state) => state.authReducer);

  const { acceptStatus, cancelStatus } = getOrderStatuses(orderStatusList);

  const handleRiderSelection = (selectedRider) => {
    // console.log("checking selected rider", selectedRider);
  };

  const [orderItems, setOrderItems] = useState([]);

  useEffect(() => {
    const riderName = data?.Table[0]?.RiderName;
    const branchName = data?.Table[0]?.BranchName;
    setSelectedRider(riderName);
    setSelectedBranch(branchName);



  }, [data]);

  function organizeOrderItems(items) {
    // First get all parent items (DealItemId is null)
    const parentItems = items.filter((item) => item.DealItemId === null);

    const result = [];

    for (const parent of parentItems) {
      // Find children - same RandomId AND DealItemId is NOT null AND not the parent itself
      const children = items.filter(
        (item) => item.RandomId === parent.RandomId && item.DealItemId !== null
      );

      result.push({
        parent,
        children,
      });
    }

    return result;
  }

  const filteredData = organizeOrderItems(data?.Table1 || []);
  const totalItemsCount = filteredData.reduce((total, item) => {
    return total + (item.children.length > 0 ? item.children.length : 1);
  }, 0);

  const initialFormValues = {
    BranchId: null,
    AreaId: null,
    OrderNumber: "",
    CustomerId: null,
    CustomerName: "",
    CustomerPhone: "",
    OrderModeId: null,
    OrderSourceId: null,
    DateFrom: "",
    DateTo: "",
    StatusId: null,
    CityId: null,
  };

  const fetchDataFromApi = () => {
    postRequest("GetOrder", {
      OperationId: 1,
      UserIP: "12.1.1.2",
      BranchId:
        selectedOrder?.BranchId ||
          (userBranchList && userBranchList.length === 1)
          ? userBranchList[0].BranchId
          : null,
      DateFrom: "2022-01-13 00:00:00.000",
      DateTo: "2023-11-13 00:00:00.000",
      CityId: userBranchList && userBranchList[0]?.CityId,
      CompanyId: userData.CompanyId,
      userId: userData?.userId,
      userData: data?.Table || [],
    })
      .then((response) => {
        if (response.data.error === true) {
          message.error(response.data.errorMessage);
          return;
        }

        if (response.data.response === false) {
          message.error(response.data.DataSet.Table.errorMessage);
          return;
        }

        const data = response.data.DataSet;
        const { Table2 } = data;

        // Populate your dropdown lists based on the data
        setOrderStatusList(Table2 || []);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleStatusChange = async (data) => {

    setOrderStatus(data.value);

    if (data.value !== null) {
      var finalDate = DateRefFrom.current;
      var finalDateTo = DateRefTo.current;

      if (+finalDate === +new Date() && +finalDateTo === +new Date()) {
        finalDate =
          finalDate.getFullYear() +
          "-" +
          (finalDate.getMonth() + 1) +
          "-" +
          finalDate.getDate() +
          " " +
          "00:00:00.000";

        finalDateTo =
          finalDateTo.getFullYear() +
          "-" +
          (finalDateTo.getMonth() + 1) +
          "-" +
          finalDateTo.getDate() +
          " " +
          "00:00:00.000";
      }

      try {
        const response = await postRequest("UpdateOrderStatus", {
          OperationId: 2,
          OrderMasterId,
          CompanyId: userData?.CompanyId,
          OrderStatusId: data.value,
          DateFrom: "2022-01-13 00:00:00.000",
          DateTo: "2023-11-13 00:00:00.000",
          userId: userData?.UserId,
          AreaId,
          OrderSourceId,
          AreaName,
          OrderNumber,
          OrderDate,
        });

        const { DataSet } = response.data;
        if (DataSet && DataSet.Table) {
          const { HasError, Error_Message, Message, Id } = DataSet.Table[0];

          if (HasError === 1) {
            console.error(`Error: ${Error_Message} - ${Message}`);
          } else {
            // console.log(`Success: ${Message}`);
          }
        }

        if (DataSet && DataSet.Table1) {
          // fetchLatestOrders();
          const orderMas = DataSet.Table1.find((item) => {
            // console.log(item);
            return data.OrderMasterId === item.OrderMasterId;
          });

          setSelectedOrder(orderMas);
        }

        if (DataSet && DataSet.Table2) {
          const orderItems = DataSet.Table2.filter((item) => {
            return data.OrderMasterId === item.OrderMasterId;
          });

          setFilteredOrders([...orderItems]);
        }

      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  const handleCombinedChange = (event) => {
    debugger;
    handleStatusChange(event);
    toggleViewOrder();
  };

  // handle status change
  const handleStatusChange2 = async (orderStatusId, orderDetials) => {
    if (!orderDetials?.OrderMasterId) return;

    try {
      const response = await postRequest("/UpdateOrderStatus", {
        OperationId: 2,
        OrderMasterId: orderDetials?.OrderMasterId,
        CompanyId: userData?.CompanyId,
        OrderStatusId: orderStatusId,
        DateFrom: "2022-01-13 00:00:00.000",
        DateTo: "2023-11-13 00:00:00.000",
        userId: userData?.UserId,
        AreaId: orderDetials?.AreaId,
        OrderSourceId: orderDetials?.OrderSourceId,
        AreaName: orderDetials?.AreaName,
        OrderNumber: orderDetials?.OrderNumber,
        OrderDate: orderDetials?.OrderDate,
      });

      const data = response?.data?.DataSet;
      const { Table6 } = data;
      onUpdateOrders(Table6);
      toggleViewOrder();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchDataFromApi();
  }, [userBranchList]);

  return (
    <Modal
      visible={viewOrder}
      onCancel={toggleViewOrder}
      footer={null}
      width={"75vw"}
      afterClose={() => {
        setIsStatusChange(false);
      }}
      style={{ top: 10 }} // Set top offset
      className="rounded-xl "
    >
      <Spin spinning={data === null}>
        <div>
          <div className="flex justify-between items-center leading-tight">
            <div className=" flex flex-row  w-full items-end">
              {/* <span className=" text-[16px] text-gray-500">Order #{data?.Table[0]?.OrderNumber.substring(data?.Table[0]?.OrderNumber.lastIndexOf("/") + 1) || "N/A"}</span> */}
              <div className="flex items-end">
                <div className="flex flex-col">
                  <span className="text-black text-2xl px-2 font-bold leading-tight">
                    Order Details
                  </span>
                  <span className="px-2 text-base flex gap-4 text-gray-500">
                    Order #
                    {
                      data?.Table[0]?.OrderNumber
                        .substring(data?.Table[0]?.OrderNumber.lastIndexOf("/") + 1) || "N/A"
                    }

                    <div className="flex  gap-2 mb-0.5">
                      <span className="leading-tight text-[16px] flex items-center gap-1">
                        <Calendar className="w-4 h-4" />{" "}
                        <span className="">
                          {data?.Table[0]?.OrderDate?.split(" ")[0]}
                        </span>
                      </span>
                      <span className="leading-tight text-[16px] flex items-center gap-1">
                        <Clock className="w-4 h-4" />{" "}
                        <span className="">
                          {data?.Table[0]?.OrderDate?.split(" ")[1]}
                        </span>


                      </span>
                    </div>
                  </span>


                </div>


              </div>

            </div>

            {userData?.RoleId !== AGENT && allowStatusChange && (
              <div>
                {isMainPage ? (
                  <Col className="mr-10 w-full">
                    {/* <div style={{ display: "flex", alignSelf: "flex-start" }}>
                  Status
                </div> */}
                    <FormSelect
                      colSpan={24}
                      listItem={orderStatusList?.filter(
                        (status) => status.OrderStatus !== "Pending"
                      )}
                      label="Status"
                      idName="OrderStatusId"
                      valueName="OrderStatus"
                      size={"large"}
                      name="OrderStatusId"
                      value={
                        isStatusChange
                          ? orderStatus
                          : data?.Table[0].OrderStatusId || ""
                      }
                      onChange={handleCombinedChange}
                      className="mr-10"
                    />
                  </Col>
                ) : (
                  <div className="flex justify-end gap-2 mr-14 ">
                    <Popconfirm
                      title="Are you sure to Cancel this Order?"
                      onConfirm={() =>
                        handleStatusChange2(
                          cancelStatus?.OrderStatusId,
                          data?.Table[0]
                        )
                      }
                      okText="Yes"
                      cancelText="No"
                      okButtonProps={{
                        style: {
                          backgroundColor: "#52c41a",
                          borderColor: "#52c41a",
                          color: "white",
                        },
                      }} // Green color for Yes
                      cancelButtonProps={{
                        style: {
                          backgroundColor: "#ff4d4f",
                          borderColor: "#ff4d4f",
                          color: "white",
                        },
                      }} // Red color for No
                    >

                      <button className="flex justify-center items-center bg-gray-white gap-3 hover:bg-red-600 hover:text-white  border bg-white x-2 py-3 rounded-lg min-w-[150px]">
                        <CloseOutlined className="" />
                        <span className="font-semibold">Cancel Order</span>
                      </button>
                    </Popconfirm>

                    <Popconfirm
                      title="Are you sure to Accept this Order?"
                      onConfirm={() =>
                        handleStatusChange2(
                          acceptStatus?.OrderStatusId,
                          data?.Table[0]
                        )
                      }
                      okText="Yes"
                      cancelText="No"
                      okButtonProps={{
                        style: {
                          backgroundColor: "#52c41a",
                          borderColor: "#52c41a",
                          color: "white",
                        },
                      }} // Green color for Yes
                      cancelButtonProps={{
                        style: {
                          backgroundColor: "#ff4d4f",
                          borderColor: "#ff4d4f",
                          color: "white",
                        },
                      }} // Red color for No
                    >

                      <button className="flex justify-center items-center gap-3 bg-[#16A34A] hover:bg-green-700 text-white px-2 py-3 rounded-lg min-w-[150px]">
                        <CheckOutlined className="font-semibold" />
                        <span className="font-semibold">Accept Order</span>
                      </button>
                    </Popconfirm>
                  </div>
                )}
              </div>
            )}

          </div>

          <div className="mt-5 w-full flex  flex-col gap-2  rounded-lg border-b border-t">
            <div className="w-full flex gap-2">
              <div className="w-[35%]  rounded-xl  p-4">
                <h1 className="font-semibold text-lg text-gray-900 mb-3">Customer Information</h1>

                <div className="flex items-center gap-3 mb-3 pb-3 border-b border-gray-100">
                  <div className="h-12 w-12 rounded-full bg-blue-100 border border-blue-100 text-lg flex items-center justify-center text-blue-600  font-semibold">
                    {data?.Table[0]?.CustomerName?.charAt(0)}
                  </div>
                  <div className="">
                    {/* todo here */}
                    <h1 className="text-xl font-bold text-gray-800 flex items-center gap-2">
                      {data?.Table[0]?.CustomerName}
                      {data?.Table[0]?.CustomerName && (
                        <button
                          onClick={() => copyToClipboard(data?.Table[0]?.CustomerName)}
                          className="text-blue-500 hover:text-blue-700 text-sm"
                        >
                          <Copy width={20} height={20} />          </button>
                      )}
                    </h1>

                    <div className="text-base text-gray-600 flex items-center">
                      <span className="tracking-wide flex gap-1 items-center">
                        {data?.Table[0]?.PhoneNumber}
                        {data?.Table[0]?.PhoneNumber && (
                          <button
                            onClick={() => copyToClipboard(data?.Table[0]?.PhoneNumber)}
                            className="text-blue-500 hover:text-blue-700 text-sm"
                          >
                            <Copy width={20} height={20} />          </button>
                        )}
                        {data?.Table[0]?.AlternateNumber && (
                          <>
                            <span className="mx-2 text-gray-400">|</span>
                            <span className="text-gray-500">Alt:</span>{" "}
                            {data?.Table[0]?.AlternateNumber}
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-3 ">
                  <div className="w-full flex gap-1 mb-1">

                    <div className="w-full flex items-center bg-white bg-opacity-10  rounded-lg px-3 py-1.5 gap-3">
                      <div className="flex flex-col ">
                        <span className="text-gray-300  leading-none ">
                          Order Mode:
                        </span>
                        <span className="text-white font-semibold text-lg">
                          {data?.Table[0]?.OrderMode}
                        </span>
                      </div>
                    </div>



                    <div className="w-full flex items-center bg-white bg-opacity-10  rounded-lg px-3 py-1.5 gap-3">

                      <div className="flex flex-col w-full">
                        <span className="text-gray-300   leading-none w-full">
                          Order Source:
                        </span>
                        <span className="text-white font-semibold text-lg ">
                          {data?.Table[0]?.OrderSourceValue}
                        </span>
                      </div>
                    </div>

                  </div>

                  <div className="w-full flex gap-1 mb-1">
                    {data?.Table[0]?.ChangeAmount > 0 && (
                      <div className="w-full flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-1.5 gap-3">
                        <div className="flex flex-col ">
                          <span className="text-gray-300  leading-none ">
                            Change Amount:
                          </span>
                          <span className="text-white ">
                            {data?.Table[0]?.ChangeAmount}
                          </span>
                        </div>
                      </div>
                    )}

                    {data?.Table[0]?.PaymentMode && (
                      <div className="w-full flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-1.5 gap-3">
                        <DollarSign className="h-5 w-5 text-white" />
                        <div className="flex flex-col w-full">
                          <span className="text-gray-300  leading-none w-full">
                            Payment Mode:
                          </span>
                          <span className="text-white ">
                            {data?.Table[0]?.PaymentMode}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className=" text-sm space-y-1">
                    {data?.Table[0]?.CityName && (
                      <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-1.5 gap-3">
                        <Building className="h-5 w-5 text-white" />
                        <div className="flex flex-col ">
                          <span className="text-gray-300 w-20 leading-none ">
                            City:
                          </span>
                          <span className="text-white ">
                            {data?.Table[0]?.CityName}
                          </span>
                        </div>
                      </div>
                    )}
                    {data?.Table[0]?.AreaName && (
                      <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-1.5 gap-3">
                        <MapPin className="h-5 w-5 text-white" />
                        <div className="flex flex-col ">
                          <span className="text-gray-300 w-20 leading-none">
                            Area:
                          </span>
                          <span className="text-white ">
                            {data?.Table[0]?.AreaName}
                          </span>
                        </div>
                      </div>
                    )}
                    {data?.Table[0]?.LandMark && (
                      <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-1.5 gap-3">
                        <Navigation className="h-5 w-5 text-white" />
                        <div className="flex flex-col ">
                          <span className="text-gray-300 w-20 leading-none">
                            LandMark:
                          </span>
                          <span className="text-white ">
                            {data?.Table[0]?.LandMark}
                          </span>
                        </div>
                      </div>
                    )}

                  </div>

                  {data?.Table[0]?.CompleteAddress && (
                    <div className="w-full mt-3">
                      <div className="flex flex-col ">
                        <span className="text-gray-300 flex  gap-1"><MapPin className="h-4 w-4 text-white mt-0.5 mr-2 shrink-0" /> Delivery Address</span>
                        <span className="text-white text-lg leading-tight flex items-center gap-2 ">
                          {data?.Table[0]?.CompleteAddress}
                          {data?.Table[0]?.CompleteAddress && (
                            <button
                              onClick={() => copyToClipboard(data?.Table[0]?.CompleteAddress)}
                              className="text-blue-100 hover:text-blue-200 text-sm"
                            >
                              <Copy width={20} height={20} />          </button>
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className=" w-[65%]  space-y-3    p-4 border-l">
                <div className="">
                  <div className="flex items-center  mb-2">
                    <div className="flex gap-2 items-center">
                      <p className="text-sm bg-red-500 text-white px-2 rounded-full">
                        {totalItemsCount}{" "}
                      </p>
                      <h3 className=" text-gray-900 text-lg font font-semibold">
                        Order Items
                      </h3>
                    </div>
                  </div>

                  <div className="max-h-[380px] overflow-y-auto pr-2 space-y-2">
                    {filteredData?.map((group, groupIndex) => (
                      <div
                        key={groupIndex}
                        className="py-2 px-2 bg-green-50 rounded-md"
                      >
                        {/* Parent Item */}
                        <div className="flex items-center gap-3 px-2">
                          {/* Image */}
                          {/* <div className="h-12 w-12 rounded-md overflow-hidden shrink-0">
                            <img
                              src={
                                group.parent.ProductImage
                                  ? process.env.REACT_APP_BASEURL + group.parent.ProductImage
                                  : ygen
                              }
                              alt=""
                              className="object-cover h-full w-full"
                            />
                          </div> */}

                          {/* Info */}
                          <div className="min-w-0 flex-1 ">
                            <div className="flex justify-between items-center">
                              <div className="text-base font-semibold text-green-700">
                                {group.parent.ProductName}{" "}
                                {group.parent.SizeName}{" "}
                                {group.parent.FlavourName}
                              </div>
                              <div className="text-base text-green-700 text-right min-w-[80px]">
                                Rs.{" "}
                                {group.parent.PriceWithGST?.toLocaleString()}
                              </div>
                            </div>
                            <div className="flex flex-wrap items-center text-sm text-green-700">
                              {group.parent.RemoteId && (
                                <span>POS: {group.parent.RemoteId}</span>
                              )}
                              <span className="mx-2">•</span>
                              <span>Quantity: {group.parent.Quantity}</span>
                              {group.parent.DiscountPercent > 0 && (
                                <>
                                  <span className="mx-2">•</span>
                                  <span className="text-rose-600">
                                    {group.parent.DiscountPercent}% OFF
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Child Items (if any) */}
                        {group.children?.length > 0 && (
                          <div className="mt-2 space-y-2 ml-8">
                            {group.children.map((child, childIndex) => (
                              <div
                                key={childIndex}
                                className="flex items-center gap-3 text-sm text-gray-700"
                              >
                                {/* <div className="h-9 w-9 rounded-md overflow-hidden shrink-0">
                                  <img
                                    src={
                                      child.ProductImage
                                        ? process.env.REACT_APP_BASEURL + child.ProductImage
                                        : ygen
                                    }
                                    alt=""
                                    className="object-cover h-full w-full"
                                  />
                                </div> */}
                                <div className="flex-1">
                                  <div className="flex justify-between items-center">
                                    <div className="font-medium">
                                      {child.ProductName} {child.SizeName}{" "}
                                      {child.FlavourName}
                                    </div>
                                    <div className="text-right min-w-[60px]">
                                      + Rs.{" "}
                                      {child.PriceWithGST?.toLocaleString()}
                                    </div>
                                  </div>
                                  <div className="text-xs text-gray-500 flex gap-1 flex-wrap">
                                    {child.RemoteId && (
                                      <span>
                                        POS: {child.RemoteId} &nbsp; Qty:{" "}
                                        {child.Quantity}
                                      </span>
                                    )}
                                    {child.DiscountPercent > 0 && (
                                      <span className="text-rose-600">
                                        {child.DiscountPercent}% OFF
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>


              </div>
            </div>



            <div className="flex  justify-between w-full gap-2 rounded-lg   px-4 py-2">
              {/* Assign Rider  */}
              <div className="basis-[60%]  rounded-md flex justify-between items-center mb-4">
                <div className="w-full flex flex-col gap-2">
                  {data?.Table[0]?.Remarks1 && (
                    <div className="w-full mb-1 bg-amber-50 border border-amber-200 rounded-md p-3 text-amber-800">
                      <div className="font-medium mb-1">
                        Special Instructions:
                      </div>
                      <div className="text-sm">{data?.Table[0]?.Remarks1}</div>
                    </div>
                  )}

                  {/* Assign rider*/}
                  {isMainPage && (
                    <div className="w-full flex gap-4">
                      {/* Rider Assignment Card */}
                      <div className="w-full bg-white rounded-lg flex items-center justify-between border border-gray-200 overflow-hidden p-4">
                        <div className="flex flex-col">
                          <span className="text-sm font-medium text-gray-700">
                            Assigned Rider
                          </span>
                          <span className="text-gray-900 text-2xl font-bold">
                            {selectedRider}
                          </span>
                        </div>

                        <div className="">
                          {isMainPage && (
                            <button
                              className="bg-blue-500 text-white px-10 py-2 rounded-lg flex gap-2"
                              onClick={() => {
                                setIsModalOpen(true);
                              }}
                            >
                              <Truck className="h-6 w-6 text-gray-100 mr-2" />
                              {selectedRider ? "Change Rider" : "Assign Rider"}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex w-full items-center justify-end">
                    <ReceiptPrint
                      orderDetails={data?.Table[0]}
                      orderItems={data?.Table1}
                    />
                  </div>

                  {/* Assign rider*/}
                  {!isMainPage && (
                    <div className="w-full flex gap-4">
                      {/* Rider Assignment Card */}
                      <div className="w-full bg-white rounded-xl flex items-center justify-between border border-gray-200 overflow-hidden p-4">
                        <div className="flex flex-col">
                          <span className="text-sm font-medium text-gray-700">
                            Branch
                          </span>
                          <span className="text-gray-900 text-2xl font-bold">
                            {selectedBranch}
                          </span>
                        </div>

                        <div className="">
                          {!isMainPage && (
                            <button
                              className="bg-blue-500 text-white px-10 py-2 rounded-lg flex gap-2 items-center"
                              onClick={() => {
                                setIsBranchModalOpen(true);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="mr-2"
                              >
                                <path d="M17 3v10" />
                                <path d="m21 7-4-4-4 4" />
                                <path d="M7 21v-10" />
                                <path d="m3 17 4 4 4-4" />
                              </svg>
                              Transfer Order to Another Branch
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  <RiderSelectModal
                    riders={ridersData?.Table14}
                    onRiderSelect={handleRiderSelection}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    orderDetials={data?.Table[0]}
                    setSelectedRider={setSelectedRider}
                  />

                  <OrderTransfer
                    branchesList={branchList}
                    orderDetials={data?.Table[0]}
                    isBranchModalOpen={isBranchModalOpen}
                    setIsBranchModalOpen={setIsBranchModalOpen}
                    setSelectedBranch={setSelectedBranch}
                  />
                </div>
              </div>


              {/* payment summary */}
              <div className="basis-[40%] bg-white rounded-xl border border-gray-200">
                <div className="w-full rounded-t-md py-2 flex items-center  text-black px-4 border-b">
                  <Receipt className="h-4 w-4 text-gray-500 mr-2" />
                  <h3 className="font-semibold text-lg text-black">
                    Payment Summary
                  </h3>
                </div>

                <div className="text-sm p-3">
                  <div className="flex justify-between">
                    <span className="text-gray-500 text-[16px] leading-tight">
                      Gross:
                    </span>
                    <span className="text-[16px] leading-tight">
                      Rs. {data?.Table[0]?.Gross?.toLocaleString() || "N/A"}
                    </span>
                  </div>

                  {
                    data?.Table[0]?.Tip > 0 && (
                      <div className="flex justify-between">
                        <span className="text-gray-500 text-[16px] leading-tight">
                          Tip:
                        </span>
                        <span className="text-[16px] leading-tight">
                          Rs. {data?.Table[0]?.Tip?.toLocaleString() || "N/A"}
                        </span>
                      </div>
                    )
                  }

                  <div className="flex justify-between">
                    <span className="text-gray-500 leading-tight text-[16px]">
                      Tax:
                    </span>
                    <span className="text-[16px] leading-tight">
                      Rs. {data?.Table[0]?.Tax?.toLocaleString() || "N/A"}
                    </span>
                  </div>

                  {data?.Table[0]?.Discount > 0 && (
                    <div className="flex justify-between">
                      <span className="text-gray-500 text-[16px] leading-tight">
                        Discount:
                      </span>
                      <span className="text-rose-600 text-[16px] leading-tight">
                        -Rs. {data?.Table[0]?.Discount?.toLocaleString()}
                      </span>
                    </div>
                  )}

                  <div className="flex justify-between">
                    <span className="text-gray-500 text-[16px] leading-tight">
                      Delivery Charges:
                    </span>
                    <span className="text-[16px] leading-tight">
                      Rs.{" "}
                      {data?.Table[0]?.DeliveryCharges?.toLocaleString() ||
                        "N/A"}
                    </span>
                  </div>

                  <div className="border-t border-gray-200 border-dashed my-1 pt-1"></div>

                  <div className="flex items-end justify-between font-semibold text-base">
                    <span className="text-[20px]">Total:</span>
                    <span className="text-emerald-600 text-2xl font-bold">
                      Rs. {data?.Table[0]?.NetAmount?.toLocaleString() || "N/A"}
                    </span>

                  </div>
                </div>
              </div>

            </div>
          </div>


        </div>
      </Spin>
    </Modal>
  );
};

export default ViewOrderModal;
